import * as ActionTypes from '../components/actions/types';

const initialState = {
  participantCheckInNum: 0,
  introductionPlay: false
};

function cmsEventInfoReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.CMS_EVENT_PARTICIPANT_CHECKINNUM:
      return {
        ...state,
        participantCheckInNum: action.total
      };
    case ActionTypes.CMS_EVENT_PARTICIPANT_CHECKINNUM_UPDATE:
      return {
        ...state,
        participantCheckInNum: state.participantCheckInNum + action.payload
      };
    case ActionTypes.CMS_EVENT_INTRODUCTION_PLAY:
      return {
        ...state,
        introductionPlay: true
      };
    case ActionTypes.CMS_CLOSE_INTRODUCTION_VIDEO:
      return {
        ...state,
        introductionPlay: false
      };
    default:
      return state;
  }
}

export default cmsEventInfoReducer;



// WEBPACK FOOTER //
// ./src/reducers/cmsEventInfo.js